import { BrowserRouter, Routes, Route } from 'react-router-dom';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Toaster } from 'react-hot-toast';
import { Layout } from './components/layout/Layout';
import { ProtectedRoute } from './components/ProtectedRoute';
import { Home } from './pages/Home';
import { Login } from './pages/Login';
import { Register } from './pages/Register';
import { Exams } from './pages/Exams';
import { ExamDetail } from './pages/ExamDetail';
import { ExamResult } from './pages/ExamResult';
import { Leaderboard } from './pages/Leaderboard';
import { Profile } from './pages/Profile';
import { Groups } from './pages/Groups';
import { AdminDashboard } from './pages/AdminDashboard';
import { AdminCms } from './pages/AdminCms';
import { AdminSettings } from './pages/AdminSettings';
import { AdminContacts } from './pages/AdminContacts';
import { AdminVideos } from './pages/AdminVideos';
import { AdminExamCreate } from './pages/AdminExamCreate';
import { DynamicPage } from './pages/DynamicPage';
import { Contact } from './pages/Contact';
import { Videos } from './pages/Videos';
import { Payments } from './pages/Payments';
import { Notifications } from './pages/Notifications';
import Friends from './pages/Friends';

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 5 * 60 * 1000, // 5 minutes
      retry: 1,
    },
  },
});

function App() {
  return (
    <QueryClientProvider client={queryClient}>
      <BrowserRouter>
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/exams" element={<Exams />} />
            <Route path="/exams/:id" element={<ExamDetail />} />
            <Route path="/exams/:id/result" element={<ExamResult />} />
            <Route path="/leaderboard" element={<Leaderboard />} />
            <Route path="/groups" element={<Groups />} />
            <Route path="/videos" element={<Videos />} />
            <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />
            <Route path="/payments" element={<ProtectedRoute><Payments /></ProtectedRoute>} />
            <Route path="/notifications" element={<ProtectedRoute><Notifications /></ProtectedRoute>} />
            <Route path="/friends" element={<ProtectedRoute><Friends /></ProtectedRoute>} />
            <Route path="/admin" element={<ProtectedRoute requireAdmin><AdminDashboard /></ProtectedRoute>} />
            <Route path="/admin/cms" element={<ProtectedRoute requireAdmin><AdminCms /></ProtectedRoute>} />
            <Route path="/admin/settings" element={<ProtectedRoute requireAdmin><AdminSettings /></ProtectedRoute>} />
            <Route path="/admin/contacts" element={<ProtectedRoute requireAdmin><AdminContacts /></ProtectedRoute>} />
            <Route path="/admin/videos" element={<ProtectedRoute requireAdmin><AdminVideos /></ProtectedRoute>} />
            <Route path="/admin/exams/create" element={<ProtectedRoute requireAdmin><AdminExamCreate /></ProtectedRoute>} />
            <Route path="/page/:slug" element={<DynamicPage />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </Layout>
      </BrowserRouter>
      <Toaster
        position="top-right"
        toastOptions={{
          duration: 3000,
          style: {
            background: '#363636',
            color: '#fff',
            borderRadius: '12px',
          },
          success: {
            iconTheme: {
              primary: '#10b981',
              secondary: '#fff',
            },
          },
          error: {
            iconTheme: {
              primary: '#ef4444',
              secondary: '#fff',
            },
          },
        }}
      />
    </QueryClientProvider>
  );
}

export default App;
